import { useState, useEffect } from 'react';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      data-testid="hero-section" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1697577418970-95d99b5a55cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlfGVufDB8fHx8MTc2MTA0Njc0OHww&ixlib=rb-4.1.0&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[#0D0D0D]/85"></div>
      
      {/* Animated grid lines */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(#00E600 1px, transparent 1px), linear-gradient(90deg, #00E600 1px, transparent 1px)',
          backgroundSize: '50px 50px',
          animation: 'gridMove 20s linear infinite'
        }}></div>
      </div>

      {/* Content */}
      <div className={`relative z-10 text-center px-4 md:px-6 transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        {/* Logo */}
        <div className="mb-8 flex justify-center" data-testid="hero-logo">
          <img 
            src="https://customer-assets.emergentagent.com/job_find-your-agent/artifacts/m94nk0ss_NYAXO.png" 
            alt="NYAXO Logo" 
            className="h-24 md:h-32 drop-shadow-[0_0_30px_rgba(0,230,0,0.5)]"
          />
        </div>

        {/* Tagline */}
        <h1 
          data-testid="hero-tagline"
          className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 tracking-wider leading-tight"
          style={{
            textShadow: '0 0 40px rgba(0,230,0,0.3)'
          }}
        >
          ENGINEERING THE FUTURE<br />
          <span className="text-[#00E600]">OF INTELLIGENCE</span>
        </h1>

        {/* Subtitle */}
        <p 
          data-testid="hero-subtitle"
          className="text-lg md:text-xl lg:text-2xl text-[#B3B3B3] max-w-4xl mx-auto mb-12 leading-relaxed"
        >
          We design AI systems that transform corporate operations — from energy and infrastructure to SaaS.
        </p>

        {/* CTA Button */}
        <button
          data-testid="hero-cta-button"
          onClick={scrollToContact}
          className="group relative px-6 md:px-10 py-3 md:py-4 bg-[#0D0D0D] text-white text-base md:text-lg font-semibold rounded-md border border-[#00E600] overflow-hidden transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,230,0,0.6)]"
        >
          <span className="relative z-10">EXPLORE OUR SOLUTIONS</span>
          <div className="absolute inset-0 bg-gradient-to-r from-[#00E600]/20 to-[#36E0A8]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </button>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#00E600] rounded-full flex justify-center">
          <div className="w-1 h-3 bg-[#00E600] rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;